<template>
<div class="announcement-box">
  <div v-if="index !== 0" class="announcement-border"></div>
  <div class="content-width">
    <h5 class="text-center">{{ msgTitle }}</h5>
    <p v-for="line in message" :key='line' class="message-line">{{ line }}</p>
    <div v-if="imageUrl" class="image-frame">
      <a v-if="link" :href="link" target="_blank" rel=”noreferrer”><img :src="imageUrl" alt="Announcement Image with link"/></a>
      <img v-else :src="imageUrl" alt="Announcement Image" />
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Announcement',
  props: ['index', 'msgTitle', 'message', 'link', 'imageUrl']
}
</script>

<style scoped>
.content-width {
  margin-bottom: 15px;
  padding: 10px 20px 10px 20px;
}

.announcement-border {
  border-top: 1px solid #8a0707;
  margin: auto;
  width: 30%;
}

.link {
  margin-top: 10px;
  margin-bottom: 0;
  word-wrap: break-word;
}

.image-frame {
  margin-top: 10px;
  margin-bottom: 0;
  text-align: center;
}

img {
  max-width: 100%;
  max-height: 100%;
}

.message-line {
  margin: 20px 0 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Announcement.vue